var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1818",
    d: "M29 6c-1.1.5-2.2.8-3.4.9 1.2-.7 2.2-1.9 2.6-3.3-1.1.7-2.4 1.2-3.8 1.4-1.1-1.2-2.6-1.9-4.3-1.9-3.8 0-6.7 3.6-5.8 7.3C9.4 10.2 5 7.8 2 4.2c-1.6 2.7-.8 6.2 1.8 7.9-1 0-1.9-.3-2.7-.7-.1 2.8 1.9 5.3 4.8 5.9-.8.2-1.8.3-2.7.1.8 2.4 3 4.1 5.6 4.1-2.5 2-5.7 2.8-8.8 2.5 2.6 1.7 5.8 2.7 9.1 2.7 11 0 17.3-9.3 16.9-17.7 1.2-.8 2.2-1.8 3-3"
  })));
}
export default SvgFtTwitter;